import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import './fonts.css';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { Theme } from './utility';

(function bootToCalendarOnce() {
  const EXEMPT = ["/login", "/error", "/logout", "/calendar", "/redirect", "/"];
  const { pathname, search, hash, href } = window.location;

  const postBootTarget = sessionStorage.getItem("postBootTarget");

    // Case 2: Special logic for "/" or "/login" when postBootTarget not yet set
  if ((pathname === "/" || pathname === "/login") && !postBootTarget) {
    if (href.includes("https://awshealthalert-dev.autodesk.com/")) {
      sessionStorage.setItem("postBootTarget", "/aws");
      return;
    }
  }
  // Case 1: Normal redirect for non-exempt paths
  if (!EXEMPT.includes(pathname)) {
    sessionStorage.setItem("postBootTarget", pathname + search + hash);
    window.history.replaceState(null, "", "/calendar");
    return;
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={Theme}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
